import ShippingPreferencesTable from "./ShippingPreferencesTable";
export default ShippingPreferencesTable;
